export default __webpack_public_path__ + "static/poedit-13846f9f5024c2a99d22bf9c1d3bec93.svg";